<ng-container *ngIf="type.sizingRuleNotification">
  <div class="blocked-product-description mb-16">
    <img src="/assets/lighting-icon-sm.svg" alt="icon" class="mr-8 mt-4" />
    <span class="fz-16 lh-24 blocked-text">
          {{ type.sizingRuleNotification }}
    </span>
  </div>
</ng-container>
